import * as Flowbite from 'flowbite-react';
import { ComponentProps } from 'react';
import { SiteSelector } from 'components/SiteSelector/SiteSelector';
import MobileNavigation from 'components/MobileNavigation';

const theme = {
    root: {
        base: 'border-r border-gray-200 border-solid fixed h-[calc(100%-68px)] z-(--z-sidebar) w-[calc(100%-var(--spacing)*10)] md:w-80',
        collapsed: {
            off: 'w-[calc(100%-var(--spacing)*10)] md:w-80',
        },
        inner: 'bg-white h-full p-0 overflow-x-hidden overflow-y-auto',
    },
};

interface SidebarProps extends Omit<ComponentProps<'div'>, 'ref'> {
    isExpanded?: boolean;
    setIsSidebarOpen: (open: boolean) => void;
}

export const Sidebar = ({
    isExpanded,
    setIsSidebarOpen,
    ...props
}: SidebarProps) => (
    <Flowbite.Sidebar
        collapsed={!isExpanded}
        collapseBehavior="hide"
        theme={theme}
        {...props}
    >
        <MobileNavigation setIsSidebarOpen={setIsSidebarOpen} />
        <SiteSelector visible={isExpanded} />
    </Flowbite.Sidebar>
);
